import { render, staticRenderFns } from "./Logistica.vue?vue&type=template&id=52ed0777&"
import script from "./Logistica.vue?vue&type=script&lang=js&"
export * from "./Logistica.vue?vue&type=script&lang=js&"
import style0 from "./Logistica.vue?vue&type=style&index=0&id=52ed0777&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports